import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { BiData } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import s from './CommentsEmptyState.scss';
var CommentsEmptyState = function (_a) {
    var total = _a.total, url = _a.url;
    var t = useTranslation().t;
    var isLoggedIn = useContext(SessionContext).isLoggedIn;
    if (total) {
        return null;
    }
    return (React.createElement("div", { className: s['root'] },
        React.createElement("img", { loading: "lazy", alt: t('deviation.comments.emptyState.illustration'), src: Url.staticCDNLink('/eclipse/promos/il5-3.svg') }),
        React.createElement(Heading, { className: s['heading'] }, t('deviation.comments.emptyState.heading')),
        isLoggedIn ? (React.createElement("div", { className: s['text'] }, t('deviation.comments.emptyState.text'))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: s['text'] }, t('deviation.comments.emptyState.text.loggedOut')),
            React.createElement("div", { className: s['cta'] },
                React.createElement(GhostButton, { size: "medium", variant: "main", href: Url.joinLink(undefined, url), biData: BiData({
                        evid: 240,
                        referral_info: ReferralType.EMPTY_COMMENT,
                    }) }, t('deviation.comments.emptyState.cta.loggedOut')))))));
};
CommentsEmptyState.displayName = 'CommentsEmptyState';
export default CommentsEmptyState;
//# sourceMappingURL=CommentsEmptyState.js.map